import { render, staticRenderFns } from "./coustomerModel.vue?vue&type=template&id=65c28f8d&scoped=true"
import script from "./coustomerModel.vue?vue&type=script&lang=js"
export * from "./coustomerModel.vue?vue&type=script&lang=js"
import style0 from "./coustomerModel.vue?vue&type=style&index=0&id=65c28f8d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c28f8d",
  null
  
)

export default component.exports